export default function CTASection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20composition%20of%20diverse%20fashion%20products%20sneakers%20handbags%20caps%20and%20accessories%20arranged%20in%20a%20harmonious%20circular%20mandala%20pattern%20on%20a%20warm%20cream%20surface%2C%20soft%20golden%20sunlight%2C%20editorial%20still%20life%20photography%2C%20rich%20textures%20and%20warm%20earthy%20tones%2C%20elegant%20and%20luxurious%20aesthetic&width=1800&height=1200&seq=cta-bg-v2&orientation=landscape"
        alt="Get Itaobuy Sheet - Start sourcing profitable products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 text-center px-6 md:px-10">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-wider">
          GET ITAOBUY SHEET
        </h2>
        <p className="text-white/80 text-sm md:text-lg font-light mt-6 max-w-xl mx-auto leading-relaxed">
          Discover Verified Suppliers
          <br />
          And Scale Your Store in 2026
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-10 px-8 py-4 bg-foreground-950 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap group"
        >
          <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
          </span>
          BUY IT NOW
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}